import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Col, Row } from 'react-bootstrap';
import { ROLE_ROOT_EMPLOYEE, ROLE_SUPERADMIN } from 'js/constants';
import may from 'js/security';
import axios from 'axios';
import Loader from 'components/layout/Loader';
import { stringifyQs } from 'helpers/http';

function CompanyFilteredSubscription(props) {
  const { inModal, entity, disabled } = props;

  const [actualFilteredSubscriptionIds, setActualFilteredSubscriptionIds] = useState(
    entity.getFilteredSubscriptionIds()
  );
  const { messages, locale } = useIntl();
  const { subscription_automation: msg } = messages;

  const updateFilteredSubscriptionIds = id => {
    if (disabled) {
      return;
    }
    const { entity, changeEntity } = props;
    let filteredSubscriptionIds = [...actualFilteredSubscriptionIds];
    if (actualFilteredSubscriptionIds.includes(id)) {
      filteredSubscriptionIds = actualFilteredSubscriptionIds.filter(item => item !== id);
    } else {
      filteredSubscriptionIds.push(id);
    }

    setActualFilteredSubscriptionIds(filteredSubscriptionIds);
    const newEntity = entity.updateValue('filteredSubscriptionIds', filteredSubscriptionIds);
    changeEntity(newEntity);
  };

  // Security
  const user = useSelector(({ login }) => login.user);
  const isAccessGranted = [ROLE_ROOT_EMPLOYEE, ROLE_SUPERADMIN].some(role => may(role, user.roles));
  if (!isAccessGranted) {
    return;
  }

  const [subscriptions, setSubscriptions] = useState([]);
  const [subscriptionsLoading, setSubscriptionsLoading] = useState(true);
  useEffect(() => {
    let filters = { type: 'client', excludeSystemSubscriptions: true };

    axios
      .get(`/api/subscriptions/list/subscriptions.json` + '?' + stringifyQs(filters))
      .then(response => {
        const { data } = response;
        setSubscriptions(data.list);
        setSubscriptionsLoading(false);
      })
      .catch(e => {
        console.error(e);
        setSubscriptionsLoading(false);
      });
  }, []);

  const columns = [
    messages.subscription_action,
    messages.subscription_name,
    messages.subscription_type,
    messages.subscription_fee,
    messages.subscription_start,
    messages.subscription_end,
  ];

  return (
    <Row>
      <Col xs={12} md={12}>
        {subscriptionsLoading ? (
          <Loader />
        ) : (
          <table
            className="table table-hover"
            style={{ width: inModal ? '100%' : '90%', maxHeight: '400px', overflowY: 'auto' }}
          >
            <thead>
              <tr>
                {columns.map((column, key) => (
                  <th key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {subscriptions.length > 0
                ? subscriptions.map(subscription => {
                  const { id, name, title, type, fee, period_start, period_end } = subscription;
                  const matchingTitle =
                    typeof title === 'object' ? title.find(({ lang }) => lang === locale)?.name : name;

                  let isSelected = actualFilteredSubscriptionIds?.includes(id);
                    return (
                      <tr key={id} className={' clickable '} onClick={() => updateFilteredSubscriptionIds(id)}>
                        <td className="v-align-middle">
                          {isSelected ? (
                            <span>
                              <i className="fa fa-check" style={{ fontSize: '17px' }} />
                            </span>
                          ) : (
                            <></>
                          )}
                        </td>
                        <td className="v-align-middle">
                          <span>{matchingTitle}</span>
                        </td>
                        <td className="v-align-middle">
                          <span>{type}</span>
                        </td>
                        <td className="v-align-middle">
                          <span>{fee}</span>
                        </td>
                        <td className="v-align-middle">
                          <span>{period_start}</span>
                        </td>
                        <td className="v-align-middle">
                          <span>{period_end}</span>
                        </td>
                      </tr>
                    );
                  })
                : [
                    <tr>
                      <td colSpan={6} className="text-center">
                        {messages.no_data}
                      </td>
                    </tr>,
                  ]}
            </tbody>
          </table>
        )}
      </Col>
    </Row>
  );
}

export default CompanyFilteredSubscription;
